import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../axiosinterceptor";

const ASSIGNUSER_API = "/code_enhance_review_workflow_user_names";

export const REQUEST_STATUS = Object.freeze({
  IDLE: "IDLE",
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
});

const initialState = {
  files: {
    data: [],
    hasMore: true,
    status: REQUEST_STATUS.IDLE,
    error: null,
  },
};

export const getAssignUserMenuData = createAsyncThunk(
  "workflow/getAssignUserMenuData",
  async (
    { pageNumber = 1, search = "" },
    { fulfillWithValue, rejectWithValue }
  ) => {
    try {
      const response = await axiosInstance.get(ASSIGNUSER_API, {
        params: {
          page_number: pageNumber,
          user_name: search,
        },
      });

      return fulfillWithValue(response.data.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong"
      );
    }
  }
);

const workflowSlice = createSlice({
  name: "workflow",
  initialState,
  reducers: {
    resetAssignUsers(state) {
      state.files.data = [];
      state.files.hasMore = true;
      state.files.status = REQUEST_STATUS.IDLE;
      state.files.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getAssignUserMenuData.pending, (state) => {
        state.files.status = REQUEST_STATUS.LOADING;
      })
      .addCase(getAssignUserMenuData.fulfilled, (state, action) => {
        state.files.status = REQUEST_STATUS.SUCCESS;

        const users = action.payload.users || [];
        const noMoreData = users.length === 0; // covers both empty array and the "no more data" message case

        if (action.meta.arg.pageNumber === 1) {
          state.files.data = users;
        } else if (!noMoreData) {
          state.files.data = [...state.files.data, ...users];
        }

        state.files.hasMore = !noMoreData; // stops pagination the moment users is empty
      })
      .addCase(getAssignUserMenuData.rejected, (state, action) => {
        state.files.status = REQUEST_STATUS.FAILURE;
        state.files.error = action.payload;
        state.files.hasMore = false;
      });
  },
});

export const { resetAssignUsers } = workflowSlice.actions;
export default workflowSlice.reducer;
